export const actions = {
    GET_ACTIVITY_COPY_DATAS: 'GET_ACTIVITY_COPY_DATAS',
    SET_ACTIVITY_COPY_DATAS: 'SET_ACTIVITY_COPY_DATAS',

    GET_ACTIVITY_LIST : 'GET_ACTIVITY_LIST',
    SET_ACTIVITY_LIST : 'SET_ACTIVITY_LIST',

    GET_START_ACTIVITY_COPY : 'GET_START_ACTIVITY_COPY',
    SET_START_ACTIVITY_COPY : 'SET_START_ACTIVITY_COPY',
};
